/* eslint-disable global-require */
// @ts-nocheck

import angular from 'angular';

import 'simplebar';
import Dropzone from 'dropzone';

require('angular-i18n/angular-locale_de-de.js');
require('angular-animate');
require('ng-table/bundles/ng-table.min');
require('ng-dropzone/dist/ng-dropzone');
require('angular-drag-and-drop-lists');

require('@khmyznikov/pwa-install');

const ngRoute = require('angular-route');
const ngSanitize = require('angular-sanitize');

window.Dropzone = Dropzone;
window.Dropzone.autoDiscover = false;

global.Buffer = global.Buffer || require('buffer').Buffer;

const DEPENDENCIES = [
  ngRoute,
  ngSanitize,
  'ngTable',
  // 'ngAnimate',
  'thatisuday.dropzone',
  'dndLists',
];

export default angular.module('autoboard.libraries', DEPENDENCIES)
  .name;
